import i18n from '@/utils/i18n';
import { Camera, CameraPermissionStatus } from '@/react-native-vision-camera';
import { usePermissionDeniedAlert } from './use-permission-denied-alert';
import { useState } from 'react';

export const useRequestCamera = () => {
  const [cameraPermissionStatus, setCameraPermissionStatus] =
    useState<CameraPermissionStatus>(Camera.getCameraPermissionStatus);

  const showPermissionDeniedAlert = usePermissionDeniedAlert();

  const requestCamera = async () => {
    if (cameraPermissionStatus === 'granted') {
      return cameraPermissionStatus;
    }

    if (cameraPermissionStatus === 'restricted') {
      showPermissionDeniedAlert(i18n.t('camera.camera_access_required'));
      return cameraPermissionStatus;
    }

    const nextPermission = await Camera.requestCameraPermission();
    if (nextPermission === 'denied') {
      showPermissionDeniedAlert(i18n.t('camera.camera_access_required'));
    }
    setCameraPermissionStatus(nextPermission);

    return nextPermission;
  };

  return {
    cameraPermissionStatus,
    requestCamera,
  };
};
